import React from 'react'

import styled from '@emotion/styled'

import Icon from './Icon'

const Banner = styled.div`
  color: ${props => props.theme.colors.bannerTextError};
  background: ${props => props.theme.colors.bannerBackgroundError};
  font-size: 1.5rem;
  border-radius: 1rem;
  padding: 1rem;
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: 1rem;
  row-gap: 1.5rem;
`

const Content = styled.p`
  ${props => props.theme.typography.bodyText};
  color: inherit;
`

const ErrorBanner = ({
  value,
  ...rest
}: {
  value: string | string[]
  'data-testid'?: string
  style?: React.ComponentProps<typeof Banner>['style']
}) => {
  const errors = Array.isArray(value) ? value : [value]

  return (
    <Banner role="alert" {...rest}>
      {errors.map((error, index) => (
        <React.Fragment key={index}>
          <Icon name="error" aria-hidden />
          <Content>{error}</Content>
        </React.Fragment>
      ))}
    </Banner>
  )
}

export default ErrorBanner
